.select {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px 6px 10px;
  border-radius: 8px;
  border: 2px solid transparent;
  background-color: var(--light-gray);
  min-height: 40px;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.teamHeader {
  font-weight: bold;
  border-radius: 9999px;
  background-color: rgb(243, 243, 243, 0.6);
  padding: 8px 16px !important;
  border-bottom: 0px;
  cursor: default;
}

/* Team headers are rendered as disabled Select.Options so they can't be
   selected as values, but Ant Design applies cursor: not-allowed to disabled
   options. Override to a neutral default cursor for the header row. */
.teamHeader:global(.ant-select-item-option-disabled) {
  cursor: default !important;
  padding: 8px 16px !important;
  border-radius: 0px !important;
}

/* Re-apply pointer cursor to the checkbox area and chevron button so they
   still feel clickable even though the parent Option is disabled. */
.teamHeader .teamCheckboxArea,
.teamHeader .teamCheckboxArea *,
.teamHeader .chevronBtn {
  cursor: pointer !important;
}

.teamHeader :global(.ant-select-item-option-state) {
  display: none !important;
}

.teamHeaderDisabled {
  color: #b0b0b0;
}

.teamHeaderEnabled {
  color: #333;
}

.teamColorDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  margin: 2px;
}

.teamNameDisabled {
  font-weight: 600;
  color: #b0b0b0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.teamNameEnabled {
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

/* The clickable left area of the team row (checkbox + dot + name). */
.teamCheckboxArea {
  flex: 1;
  min-width: 0;
  padding: 4px 0;
  overflow: hidden;
}

/* When the whole team is disabled, make the checkbox area show not-allowed cursor. */
.teamCheckboxAreaDisabled,
.teamCheckboxAreaDisabled * {
  cursor: not-allowed !important;
}

/* The team-level Ant Design Checkbox. */
.teamCheckbox {
  flex-shrink: 0;
}

/* Chevron expand/collapse button — frameless, transparent. */
.chevronBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  flex-shrink: 0;
  line-height: 0;
  transition: background-color 0.15s ease;
}

.chevronBtn:hover:not(:disabled) {
  background-color: #ebebeb;
}

.chevronBtn:disabled {
  cursor: default !important;
  opacity: 0.4;
}

/* "No users" label shown in place of the chevron for empty teams. */
.noUsersText {
  font-size: 12px;
  font-weight: 400;
  color: var(--text-secondary);
  margin-left: 8px;
  flex-shrink: 0;
}

.userRow {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 400;
}

.userRowEnabled {
  color: var(--text-primary);
  cursor: pointer;
}

.userRowDisabled {
  color: #b0b0b0;
  cursor: not-allowed;
}

/* Hide Ant Design's built-in selection highlight and indicator on options. */
.userOption:global(.ant-select-item-option-selected) {
  background-color: transparent !important;
}

.userOption :global(.ant-select-item-option-state) {
  display: none !important;
}

.userOption :global(.ant-select-item-option-content) {
  font-weight: 400 !important;
}

/* User option display text — truncates with ellipsis so EllipsisTooltip
   can detect overflow and show the full name in a tooltip. */
.userOptionText {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: inherit;
}

.select:global(.ant-select-multiple) :global(.ant-select-placeholder) {
  color: var(--text-secondary) !important;
  inset-inline-start: 0px !important;
}

.inlineContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Ant Design normally portals and absolutely positions this popup. For the
   Copilot question, keep the initially-open list in document flow so the
   question card expands around it instead of covering nearby content. */
.inlinePopup {
  position: static !important;
  inset: auto !important;
  width: 100% !important;
  max-width: 100%;
  margin-top: 8px;
  transform: none !important;
  box-shadow: none;
}

.inlinePopup :global(.ant-select-item) {
  font-size: 12px;
}

/* Dark mode: the light-theme literals above (60% #f3f3f3 band, #333 / #b0b0b0
   text, #ebebeb hover) glare or vanish on the dark dropdown. */
:root[data-theme='dark'] .teamHeader {
  background-color: var(--light-gray);
}

:root[data-theme='dark'] .teamHeaderEnabled,
:root[data-theme='dark'] .teamNameEnabled {
  color: var(--text-primary);
}

:root[data-theme='dark'] .teamHeaderDisabled,
:root[data-theme='dark'] .teamNameDisabled,
:root[data-theme='dark'] .userRowDisabled {
  color: var(--text-tertiary);
}

:root[data-theme='dark'] .chevronBtn:hover:not(:disabled) {
  background-color: var(--surface-hover);
}

.popupScroll {
  max-height: 315px;
  overflow-y: auto;
}

.popupSearch {
  margin: 8px 16px;
}

.tagWrapper {
  display: inline-flex;
  margin: 2px 4px 2px 0;
}

/* A chevron the screen passes in for the team rows: it turns over when its team opens. */
.givenChevron {
  display: flex;
  transition: transform 0.2s ease;
}

.givenChevronOpen {
  transform: rotate(180deg);
}
